import { ssm, StoreObservable } from './store-manager';

export const STORAGE_KEY = 'VKYC_THEME';

interface IThemeData {
  primaryColor: string;
  primaryLightColor: string;
  primaryFocusColor: string;
  primaryLinearEndColor: string;
  primaryTagBgColor: string;
  primaryErrorColor: string;
  primaryBorderColor: string;
  mobileWidth: number;
  mobileBgColor: string;
  pcBgColor: string;
}

class ThemeStore {
  private static DEFAULT_VALUE: IThemeData = {
    primaryColor: '#30B043',
    primaryLightColor: '#E3F4E6',
    primaryFocusColor: '#f0fbf2',
    primaryLinearEndColor: '#5ED878',
    primaryTagBgColor: '#DCEFDF',
    primaryErrorColor: '#DE5753',
    primaryBorderColor: 'rgba(48,176,67,0.20)',
    mobileWidth: 900,
    mobileBgColor: '#f9f9f9',
    pcBgColor: '#f5f5f5',
  };
  private store: StoreObservable<IThemeData>;

  constructor() {
    this.store = ssm.getStoreObservable<IThemeData>(STORAGE_KEY);
    this.store.setDefault(() => ThemeStore.DEFAULT_VALUE);
  }

  getData(): IThemeData {
    return this.store.getNotNull();
  }

  getPrimaryColor(): string {
    return this.store.getNotNull().primaryColor;
  }

  getPrimaryBorderColor(): string {
    return this.store.getNotNull().primaryBorderColor;
  }

  getPrimaryFocusColor(): string {
    return this.store.getNotNull().primaryFocusColor;
  }

  getPrimaryLinearEndColor(): string {
    return this.store.getNotNull().primaryLinearEndColor;
  }

  getPrimaryTagBgColor(): string {
    return this.store.getNotNull().primaryTagBgColor;
  }

  getPrimaryErrorColor(): string {
    return this.store.getNotNull().primaryErrorColor;
  }

  updatePrimaryColor = (data: string) => {
    console.log('update primary color ', data);
    this.store.setMember((v) => {
      v.primaryColor = data;
    });
    this.changeTheme(this.getPrimaryColor());
  };

  updateLightColor = (data: string) => {
    this.store.setMember((v) => {
      v.primaryLightColor = data;
    });
  };

  updateData = (data: IThemeData) => {
    this.store.set(data);
  };

  clearData = () => {
    this.store.clear();
    localStorage.removeItem(STORAGE_KEY);
  };

  changeTheme = (color: string) => {
    console.log('change theme color', color);
  };

  initTheme = () => {
    console.log('init theme color: ', this.getPrimaryColor());
    this.updatePrimaryColor(this.getPrimaryColor());
    // change style node for lazy load
    const styleObserver = new MutationObserver(() => {
      const styleNode = document.getElementById('dynamic_antd_theme_custom_style');
      if (styleNode && document.head.lastElementChild !== styleNode) {
        document.head.append(styleNode);
      }
    });
    styleObserver.observe(document.head, { childList: true });
  };

  resetTheme = () => {
    this.clearData();
    this.updatePrimaryColor(ThemeStore.DEFAULT_VALUE.primaryColor);
  };
}

const themeStore = new ThemeStore();

export default themeStore;
